export default __webpack_public_path__ + "static/media/5-Brid Spa-17.cd4d30a6.jpg";